// Color encoding constants for report management and analytics
export const REPORT_COLOR_ENCODING = {
  GRAFFITI: "#6f42c1",
  ISSUE_IMAGE: "#1f6ae1",
  OTHER_ISSUE: "#f4b400",
  DAMAGE: "#6c757d",
  EMERGENCY: "#B71C1C",
  REGULAR_CLEANING: "#90EE90",
  STANDARD_DEEP_CLEANING: "#f57c00",
  ANNUAL_DEEP_CLEANING: "#ff9999",
  NON_EMERGENCY: "#2E86C1",
};
